import React from 'react';
import { Heading } from '../../common/form/form-parts';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const SwedishPrivateManualReview = (props) => {
    const { successfulSubmissionData, helpUrl } = props;
    return (
        <>
            <div />
            <div className={'mt-7'}>
                <Heading>Vi håller på att verifiera dina uppgifter</Heading>
                <div className={'mb-3'}>
                    Ditt konto kommer att aktiveras så fort det har granskats.
                    Vi skickar ett e-postmeddelande till{' '}
                    {successfulSubmissionData.emailAddress} så fort det är
                    klart. Under tiden kan du fortsätta använda Tradera som
                    oinloggad.
                </div>
                <Button
                    theme="primary"
                    fluid
                    className="my-3"
                    href={successfulSubmissionData.redirectLink}>
                    Gå till Tradera
                </Button>
                <div className={'text-center mb-3'}>
                    Har du problem? <a href={helpUrl}>Kontakta oss</a>
                </div>
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
